module.exports = __webpack_public_path__ + "img/downchevron.42d2757f.svg";